import { atom } from 'recoil'
import UserProfile from '../models/userProfile'

export const userProfileAtom = atom<UserProfile>({
  key: 'userProfile',
  default: undefined
})
